import { render, staticRenderFns } from "./patientsPortalContactList.vue?vue&type=template&id=049df386&"
import script from "./patientsPortalContactList.vue?vue&type=script&lang=js&"
export * from "./patientsPortalContactList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports